/**
 * Custom error codes for PSF.
 *
 * Starts with 4900, as shaka error codes related
 * to manifest are 4xxx, but end below 4100 currently.
 */ export var PsfErrorCode = /*#__PURE__*/ function(PsfErrorCode) {
    /**
     * File does not follow JSON syntax.
     */ PsfErrorCode[PsfErrorCode["INVALID_JSON"] = 4900] = "INVALID_JSON";
    /**
     * Cannot find drm info by id.
     */ PsfErrorCode[PsfErrorCode["MISSING_DRM_INFO"] = 4901] = "MISSING_DRM_INFO";
    /**
     * Cannot find timeline by id.
     */ PsfErrorCode[PsfErrorCode["MISSING_TIMELINE"] = 4902] = "MISSING_TIMELINE";
    return PsfErrorCode;
}({});

//# sourceMappingURL=error-codes.js.map